import { Fragment } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { StyledRow, TableRow } from './_table_row.component';
import { SkeletonRows } from './_table_skeleton_rows.component';
import { TableColumn, TableProps } from './table.component';
import { theme } from './table.theme';

export const StyledEmptyStateCell = styled.td`
	box-sizing: border-box;
	padding: ${coreTokens.spacing.x4} ${coreTokens.spacing.x1_5};
	text-align: center;
	font: ${theme.getValue('bodyFont')};
	color: ${theme.getValue('emptyStateTextColor')};
`;

export function TableBody<TRow>({
	columns,
	rows,
	loading,
	skeletonRows,
	emptyState,
	emptyStateText,
	onRowClick,
	getRowActionLabel,
	getRowKey,
}: {
	columns: TableColumn<TRow>[];
	rows: TRow[];
	loading: boolean;
	skeletonRows: number;
	emptyState: TableProps<TRow>['emptyState'];
	emptyStateText: string;
	onRowClick: TableProps<TRow>['onRowClick'];
	getRowActionLabel: TableProps<TRow>['getRowActionLabel'];
	getRowKey: (row: TRow) => string | number;
}): JSX.Element {
	if (loading) {
		return <SkeletonRows columns={columns} rows={skeletonRows} />;
	}

	if (rows.length === 0) {
		return (
			<StyledRow>
				<StyledEmptyStateCell colSpan={columns.length}>{emptyState ?? emptyStateText}</StyledEmptyStateCell>
			</StyledRow>
		);
	}

	return (
		<Fragment>
			{rows.map((row) => (
				<TableRow key={getRowKey(row)} row={row} columns={columns} onRowClick={onRowClick} getRowActionLabel={getRowActionLabel} />
			))}
		</Fragment>
	);
}
